import { useState } from "react";
import SyntaxHighlighter from 'react-syntax-highlighter';
import darkTheme from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark';
import "./AppCodeSnippet.scss";
import { formatXML } from "../../constants/apiUtil";

const API_DOC_TEXT = '#e2e3e5';
const API_DOC_TAG_NAME = '#ff333a';
const apiDocTheme = {
	hljs: { display: 'block', background: '#000', color: API_DOC_TEXT },
	'hljs-tag': { color: API_DOC_TEXT },
	'hljs-name': { color: API_DOC_TAG_NAME },
	'hljs-attr': { color: API_DOC_TAG_NAME },
	'hljs-string': { color: API_DOC_TEXT },
	'hljs-comment': { color: API_DOC_TEXT, fontStyle: 'italic' },
	'hljs-meta': { color: API_DOC_TEXT },
};

type AppCodeSnippetProps = {
	snippet: string;
	variant?: "default" | "apidoc";
};

const AppCodeSnippet = ({ snippet, variant = "default" }: AppCodeSnippetProps) => {
	const code = snippet.replace("<pre>", "").replace("</pre>", "").trim();
	const [copied, setCopied] = useState(false);
	const formattedXML = formatXML(code, '    ');
	const isApiDoc = variant === "apidoc";
	const handleClick = () => {
		navigator.clipboard.writeText(formattedXML).then(() => {
			setCopied(true);
			setTimeout(() => {
				setCopied(false);
			}, 2000);
		}).catch((err) => {
			console.log('Failed to copy: ', err);
		}
		)
	};
	return (
		<div className={`code-container${isApiDoc ? " code-container--figma" : ""}`}>
			<button onClick={handleClick}>{copied ? 'Copied!' : 'Copy'}</button>
			<SyntaxHighlighter
				language="xml"
				style={isApiDoc ? apiDocTheme : darkTheme}
				showLineNumbers
				wrapLongLines={false}
				lineNumberStyle={isApiDoc ? { color: API_DOC_TEXT, minWidth: '20px', paddingRight: '12px', textAlign: 'right' } : undefined}
				customStyle={isApiDoc ? {
					margin: 0,
					fontSize: '16px',
					lineHeight: '22px',
					maxHeight: '700px',
					overflowX: 'auto',
					overflowY: 'auto',
				} : {
					margin: 0,
					fontSize: '14px',
					lineHeight: '1.5em',
					maxHeight: 'calc(32.5 * 1.5em)',
					overflowX: 'auto',
					overflowY: 'auto',
				}}
				codeTagProps={{ style: { whiteSpace: 'pre', ...(isApiDoc ? { fontFamily: 'inherit' } : {}) } }}
			>
				{formattedXML}
			</SyntaxHighlighter>
		</div>
	);
};

export default AppCodeSnippet;
